export default __webpack_public_path__ + "static/blob6-911de01920ef89e0911502dc7de2c104.svg";